import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import IMAGES from '../images';
import './Home.css';

// ── Intro Band ───────────────────────────────────────────────
function IntroBand() {
  return (
    <div className="intro-band">
      <p>
        Robinetterie &amp; Accessoires De Salle De Bain{' '}
        <span className="intro-band__gold">— Artisanat Tunisien</span>
        <br />
        Laiton Massif · Marbre · Céramique · Acier Époxy
      </p>
    </div>
  );
}

// ── Collection Card ──────────────────────────────────────────
function CollectionCard({ img, label, title, link }) {
  return (
    <Link to={link} className="col-card">
      <div className="col-card__img-wrap">
        <img src={img} alt={title} className="col-card__img" />
      </div>
      <div className="col-card__overlay">
        <span className="col-card__label">{label}</span>
        <h3 className="col-card__title">{title}</h3>
        <span className="col-card__cta">Voir la collection →</span>
      </div>
    </Link>
  );
}

// ── Vasque Card ──────────────────────────────────────────────
function VasqueCard({ img, title, link }) {
  return (
    <Link to={link} className="vasque-card">
      <img src={img} alt={title} className="vasque-card__img" />
      <div className="vasque-card__overlay">
        <h3 className="vasque-card__title">{title}</h3>
        <span className="vasque-card__cta">Découvrir →</span>
      </div>
    </Link>
  );
}

// ── Accessory Card ───────────────────────────────────────────
function AccCard({ img, title, link }) {
  return (
    <Link to={link} className="acc-card">
      <div className="acc-card__img-wrap">
        <img src={img} alt={title} className="acc-card__img" />
      </div>
      <h4 className="acc-card__title">{title}</h4>
    </Link>
  );
}

// ── Brand Split ──────────────────────────────────────────────
function BrandSplit() {
  return (
    <section className="brand-split">
      <div className="brand-split__img">
        <img src={IMAGES.vasquesMarbre} alt="Khansa Yazidi Brand" />
      </div>
      <div className="brand-split__content">
        <span className="section-label">Notre Histoire</span>
        <h2 className="brand-split__title">
          Khansa Yazidi,<br />Le Brand
        </h2>
        <div className="brand-split__divider" />
        <p className="brand-split__text">
          Fondée en 2017, Khansa Yazidi est une marque artisanale tunisienne de robinetterie
          et d'accessoires de salle de bain alliant plusieurs matériaux tel que le laiton massif,
          le marbre, la céramique et l'acier Epoxy.
        </p>
        <p className="brand-split__text">
          L'ensemble des créations sont entièrement façonnées à la main épousant des formes
          épurées et minimalistes.
        </p>
        <p className="brand-split__quote">
          « Une réinterprétation de l'espace Salle de bain ! »
        </p>
      </div>
    </section>
  );
}

// ── Designer Split ───────────────────────────────────────────
function DesignerSplit() {
  return (
    <section className="designer-split">
      <div className="designer-split__content">
        <span className="section-label">Le Designer</span>
        <h2 className="designer-split__title">
          Khansa Yazidi,<br />le Designer
        </h2>
        <div className="designer-split__divider" />
        <p className="designer-split__text">
          Architecte d'intérieur, Khansa Yazidi a fait ses études supérieures à l'École
          Supérieure des Sciences et Technologies du Design de Tunis, clôturant son cursus
          par un master de recherche en design espace en Juin 2016.
        </p>
        <p className="designer-split__text">
          Elle lance sa marque de robinetterie et d'accessoires de salle de bain artisanaux
          à 25 ans, après avoir fait ses preuves à Marrakech en tant qu'architecte d'intérieur.
        </p>
        <Link to="/contact" className="btn-outline-dark" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
          En Savoir Plus
        </Link>
      </div>
      <div className="designer-split__img">
        <img src={IMAGES.designer} alt="Khansa Yazidi Designer" />
      </div>
    </section>
  );
}

// ── Certificat ───────────────────────────────────────────────
function Certificat() {
  return (
    <section className="certificat">
      <div className="certificat__inner">
        <span className="section-label">Garantie d'Authenticité</span>
        <h2 className="certificat__title">Certificat d'authenticité</h2>
        <div className="certificat__divider" />
        <p className="certificat__text">
          Chaque pièce Khansa Yazidi est accompagnée d'un certificat d'authenticité,
          garantissant son origine artisanale et la qualité irréprochable des matériaux utilisés.
          Une promesse de savoir-faire tunisien transmis de génération en génération.
        </p>
        <Link to="/contact" className="btn-outline-white">En savoir plus</Link>
      </div>
    </section>
  );
}

// ── Presse ───────────────────────────────────────────────────
const PRESS = [
  {
    pub: 'Design Magazine',
    quote:'Des créations qui allient avec grâce tradition artisanale et modernité épurée, signant un style résolument tunisien.',
  },
  {
    pub: 'Art & Décoration',
    quote: `Khansa Yazidi réinvente l'espace salle de bain avec une élégance rare et une sophistication intemporelle.`,
  },
  {
    pub: 'Maison & Objet Paris',
    quote: `Le laiton martelé à la main, une signature qui s'impose avec brio dans le paysage du design méditerranéen.`,
  },
];

function Presse() {
  return (
    <section className="presse">
      <div className="section-header">
        <span className="section-label">Ils parlent de nous</span>
        <h2 className="section-title">Presse</h2>
        <div className="section-divider" />
      </div>
      <div className="presse__grid">
        {PRESS.map((item) => (
          <div key={item.pub} className="presse__card">
            <div className="presse__pub">{item.pub}</div>
            <blockquote className="presse__quote">"{item.quote}"</blockquote>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── HOME PAGE ────────────────────────────────────────────────
export default function Home() {
  return (
    <main>
      <Hero />
      <IntroBand />

      {/* ROBINETTERIE */}
      <div className="section-header">
        <span className="section-label">Savoir-faire</span>
        <h2 className="section-title">Robinetterie</h2>
        <div className="section-divider" />
      </div>
      <section className="collections-grid">
        <CollectionCard img={IMAGES.douches}       label="Collection" title="Douches"          link="/robinetterie/douches" />
        <CollectionCard img={IMAGES.robinetsPoser} label="Collection" title="Robinets À Poser" link="/robinetterie/poser"   />
        <CollectionCard img={IMAGES.robinetsMuraux} label="Collection" title="Robinets Muraux" link="/robinetterie/muraux"  />
      </section>

      <BrandSplit />

      {/* VASQUES */}
      <div className="section-header">
        <span className="section-label">Matières Nobles</span>
        <h2 className="section-title">Vasques</h2>
        <div className="section-divider" />
      </div>
      <section className="vasques-grid">
        <VasqueCard img={IMAGES.vasquesMarbre}    title="Vasques en Marbre"        link="/vasques/marbre"    />
        <VasqueCard img={IMAGES.vasquesLaiton}    title="Vasques en Laiton Martelé" link="/vasques/laiton"   />
        <VasqueCard img={IMAGES.vasquesCeramique} title="Vasques en Céramique"     link="/vasques/ceramique" />
      </section>

      <DesignerSplit />

      {/* ACCESSOIRES */}
      <div className="section-header">
        <span className="section-label">Compléments</span>
        <h2 className="section-title">Accessoires</h2>
        <div className="section-divider" />
      </div>
      <section className="accessories-grid">
        <AccCard img={IMAGES.robinetsMuraux} title="Porte-Savons"      link="/accessoires/porte-savons"    />
        <AccCard img={IMAGES.robinetsPoser}  title="Porte-Serviettes"  link="/accessoires/porte-serviettes" />
        <AccCard img={IMAGES.douches}        title="Miroirs"            link="/accessoires/miroirs"         />
        <AccCard img={IMAGES.vasquesCeramique} title="Bougeoirs"        link="/accessoires/bougeoirs"       />
      </section>

      <Certificat />
      <Presse />
    </main>
  );
}
